<template>

    <div class="vx-row">
        <div class="vx-col w-2/3">
            <vs-card>
                <vs-input v-model="name" class="w-full" placeholder="Naam"></vs-input>
            </vs-card>
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Beschrijving</h5>
                </div>
                <div>
                    <vs-textarea v-model="description" height="250px"></vs-textarea>
                </div>
            </vs-card>
        </div>
        <div class="vx-col w-1/3">
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Sla product op!</h5>
                </div>
                <div>
                    <vs-checkbox v-model="multiple" :vs-value="true">Meerdere opties mogelijk?</vs-checkbox>
                    <vs-input v-model="position" class="w-full mb-4" placeholder="Positie"></vs-input>
                    <vs-button @click="editCategory">Opslaan</vs-button>
                </div>
            </vs-card>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            position: '',
            description: '',
            multiple: false,
            name: ''
        }
    },
    created() {
        this.getCategory();
    },
    mounted() {
        this.$events.listen('company-selected', (e) => {
            this.$router.replace({name: 'companies-products-options', params: {'slug': e.slug}})
        });
    },
    computed: {
        staffRoute () {
            if(this.$route.meta.staff) {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
            } else {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
                return false
            }
        },
    },
    methods: {
        getCategory: function() {
            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/addon-category' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/addon-category'
            this.$http.get(url, {
                params: {
                    'id': this.$route.params.category
                },
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then((response) => {
                console.log(response.data);
                this.position = response.data.position
                this.name = response.data.name
                this.description = response.data.description
                this.multiple = response.data.multiple == 0 ? false : true
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            });
        },
        editCategory() {
            let formData = new FormData();

            formData.append('_method', 'PUT');
            formData.append( 'id', this.$route.params.category);
            formData.append('name', this.name);
            formData.append('position', this.position);
            formData.append('description', this.description);
            formData.append('multiple', this.multiple === false ? 0 : 1);

            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/addon-category/update' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/addon-category/update'
            this.$http.post(url, formData,
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                console.log(response)
                this.$router.push({'name': 'companies-products-option-categories'});
                this.$vs.notify({
                    title: 'Success',
                    text: 'Succesvol opgeslagen',
                    color: 'success'
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })
        }
    }
}
</script>

<style>

</style>
